import axios from 'axios'

const API_ENDPOINT = window.config.ssURL + 'dashboards'

export default {
    fetchDashboardClientLevels() {
        return axios.get(API_ENDPOINT + '/dashboard-client-levels')
    }
}
